import { render, staticRenderFns } from "./FeaturedArticles.vue?vue&type=template&id=fc21f292&scoped=true&"
import script from "./FeaturedArticles.vue?vue&type=script&lang=js&"
export * from "./FeaturedArticles.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedArticles.vue?vue&type=style&index=0&id=fc21f292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc21f292",
  null
  
)

export default component.exports